export default function TestimonialsSection() {
  const featured = {
    name: "Marcus Rivera",
    role: "Fitness Coaching Group Owner",
    avatar: "https://ui-avatars.com/api/?name=Marcus+Rivera&background=7c3aed&color=fff&size=100&bold=true",
    quote: "ClickSendAI grew my Skool group from 200 to 1,400 members in just 3 months. The AI content is so on-brand that people genuinely think I have a full marketing team. I spend maybe 20 minutes a week reviewing posts — everything else is on autopilot.",
    metric1: { value: "+600%", label: "Group Growth" },
    metric2: { value: "3 months", label: "Time to Results" },
    metric3: { value: "20 min/wk", label: "Time Invested" },
  };

  const testimonials = [
    {
      name: "Sarah Chen",
      role: "Digital Marketing Group Owner",
      avatar: "https://ui-avatars.com/api/?name=Sarah+Chen&background=ec4899&color=fff&size=100&bold=true",
      quote: "I was spending 15 hours a week on social media. Now ClickSendAI handles everything and I get better results. It&apos;s genuinely magical.",
      metric: "15hrs/week saved",
      stars: 5,
    },
    {
      name: "James Okafor",
      role: "Business Coach & Group Owner",
      avatar: "https://ui-avatars.com/api/?name=James+Okafor&background=0ea5e9&color=fff&size=100&bold=true",
      quote: "The analytics dashboard alone is worth the price. I can see exactly which posts bring in new members and double down on what works.",
      metric: "3x member acquisition",
      stars: 5,
    },
    {
      name: "Emma Thornton",
      role: "Online Course Creator",
      avatar: "https://ui-avatars.com/api/?name=Emma+Thornton&background=10b981&color=fff&size=100&bold=true",
      quote: "Set up in 20 minutes, posting to 12 platforms by the end of the day. My group is now the most visible in my niche.",
      metric: "12 platforms connected",
      stars: 5,
    },
    {
      name: "David Park",
      role: "SaaS Founder & Group Owner",
      avatar: "https://ui-avatars.com/api/?name=David+Park&background=f59e0b&color=fff&size=100&bold=true",
      quote: "We went from 50 to 800 members in 6 weeks. The AI understands our niche perfectly and the content quality is incredible.",
      metric: "1,500% growth in 6 weeks",
      stars: 5,
    },
    {
      name: "Priya Sharma",
      role: "Wellness & Mindfulness Group Owner",
      avatar: "https://ui-avatars.com/api/?name=Priya+Sharma&background=8b5cf6&color=fff&size=100&bold=true",
      quote: "The content sounds exactly like me. My audience had no idea it was AI-generated until I told them. That&apos;s how good it is.",
      metric: "Zero hours on content",
      stars: 5,
    },
    {
      name: "Tom Whitfield",
      role: "Real Estate Investing Group Owner",
      avatar: "https://ui-avatars.com/api/?name=Tom+Whitfield&background=ef4444&color=fff&size=100&bold=true",
      quote: "I manage 3 groups with the Agency plan. ClickSendAI handles all the marketing for all three. It&apos;s like having 3 marketing teams for $299/mo.",
      metric: "3 groups, 1 dashboard",
      stars: 5,
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Success Stories
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Real Results from Real{" "}
            <span className="bg-gradient-to-r from-violet-600 to-fuchsia-500 bg-clip-text text-transparent">
              Automators
            </span>
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Join hundreds of group, membership and community owners growing their groups on autopilot.
          </p>
        </div>

        {/* Featured testimonial */}
        <div className="bg-gradient-to-br from-violet-600 to-fuchsia-600 rounded-2xl p-8 md:p-10 mb-8 text-white">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-1">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-300 text-lg"></i>
                ))}
              </div>
              <blockquote className="text-xl md:text-2xl font-medium leading-relaxed mb-6 text-white/95">
                &ldquo;{featured.quote}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3">
                <img src={featured.avatar} alt={featured.name} className="w-12 h-12 rounded-full object-cover object-top border-2 border-white/30" />
                <div>
                  <div className="font-bold text-white">{featured.name}</div>
                  <div className="text-sm text-white/70">{featured.role}</div>
                </div>
              </div>
            </div>
            <div className="flex flex-row md:flex-col gap-4 md:gap-6 shrink-0">
              {[featured.metric1, featured.metric2, featured.metric3].map((m) => (
                <div key={m.label} className="bg-white/15 rounded-xl p-4 text-center min-w-[100px]">
                  <div className="text-2xl font-black text-white">{m.value}</div>
                  <div className="text-xs text-white/70 mt-1">{m.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Grid testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-white rounded-2xl p-6 border border-gray-100 flex flex-col gap-4">
              <div className="flex items-center gap-0.5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-violet-100 text-violet-700 text-xs font-semibold w-fit">
                <i className="ri-arrow-up-line text-emerald-500"></i>
                {t.metric}
              </div>
              <div className="flex items-center gap-3 pt-2 border-t border-gray-50">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover object-top" />
                <div>
                  <div className="text-sm font-semibold text-gray-900">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
